import type { Messages } from '../de';

export default {
  kind: {
    clear: 'Sunny',
    partly: 'Partly cloudy',
    cloudy: 'Cloudy',
    fog: 'Fog',
    drizzle: 'Drizzle',
    rain: 'Rain',
    snow: 'Snow',
    storm: 'Thunderstorm',
  },
  compass: {
    n: 'N', ne: 'NE', e: 'E', se: 'SE', s: 'S', sw: 'SW', w: 'W', nw: 'NW',
  },
  badge: '{kind}, {temp}',
  card: {
    aria: 'Weather',
    title: 'Weather',
    feels: 'Feels like',
    startEnd: 'Start → end',
    wind: 'Wind',
    windValue: '{speed} from {dir}',
    windTip: 'Wind from {deg}° ({dir}); the arrow shows where it blows',
    gusts: 'Gusts',
    precip: 'Precipitation',
    dry: 'dry',
    clouds: 'Cloud cover',
    humidity: 'Humidity',
    routeWind: 'Wind along the route',
    head: 'Headwind',
    cross: 'Crosswind',
    tail: 'Tailwind',
    headComponent: 'avg {value} headwind component',
    tailComponent: 'avg {value} tailwind component',
    calm: 'little wind – direction hardly matters',
    routeTip: 'Direction of travel per section against the wind direction of that hour: ±45° headwind, from 135° tailwind, crosswind in between; weighted by distance.',
    forecast: 'Model data of the last few days; the reanalysis does not replace it automatically.',
    foot: 'Hourly model values at the start point rounded to ~1 km, not a measurement on site.',
    attribution: 'Weather data: {provider} ({license})',
  },
  analysis: {
    titleRun: 'Pace and heart rate by temperature',
    titleRide: 'Speed by headwind',
    subRun: 'One dot per run from 1 km · line: median per temperature band',
    subRide: 'One dot per ride · x: average headwind component along the route (negative = tailwind)',
    xTemp: 'Temperature °C',
    xHead: 'Headwind km/h',
    median: 'Median per band',
    bin: '{label}: n = {n}',
    binLow: '{label}: n = {n}, too few',
    nLow: '{n} – too few',
    tableLabel: 'Band',
    tableN: 'Sessions',
    tablePace: 'Median pace',
    tableSpeed: 'Median speed',
    tableMpb: 'm / beat',
    lowNote: 'Bands with fewer than {n} sessions are faded and do not count for the summary.',
    without: { one: '{count} session without weather (indoor, no GPS or not fetched yet).', other: '{count} sessions without weather (indoor, no GPS or not fetched yet).' },
    empty: 'No sessions with weather yet.',
    off: 'Weather is switched off in the settings.',
    chartLabel: { one: 'Scatter plot of {count} session against the weather.', other: 'Scatter plot of {count} sessions against the weather.' },
    tip: '{date} · {temp} · {value}',
    tipRide: '{date} · headwind {head} · {value}',
  },
  records: {
    title: 'Weather records',
    sub: { one: 'From {count} session with weather (Open-Meteo)', other: 'From {count} sessions with weather (Open-Meteo)' },
    empty: 'No sessions with weather yet.',
    aria: '{label}: {value}, {when}',
  },
  wrapped: {
    kicker: 'Weather · {short}',
    label: '{title} {text}',
  },
  settings: {
    status: 'Status',
    on: 'On',
    off: 'Off',
    switchOn: 'On – switch off',
    switchOff: 'Off – switch on',
    switchLabel: 'Weather on activities',
    counts: '{with} of {gps} activities with GPS have weather, {pending} pending · {files} responses in the archive',
    lastRun: 'Last fetch {ago}: {requests} requests',
    lastError: 'Last fetch {ago} stopped: {error}',
    backfill: 'First backfill for the whole history: {cmd} (use {dry} to only count). After that, weather follows every sync and import on its own.',
    sent: 'Only sent: the start point rounded to two decimals (~1 km), the time span and the list of weather values. Indoor sessions and those without GPS get no weather.',
    source: 'Source',
    license: 'Licence',
  },
} satisfies Messages['weather'];
